// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imageCheck_wrapper__21dQe","tableWrapper":"imageCheck_tableWrapper__13zCS"};